import defaultTab from './defaultTab'
import filterQuestions from './filterQuestions'
import getCardStyle from './getCardStyle'
import resolveEvidences from './resolveEvidences'
import status from './status'
import statusChipColor from './statusChipColor'

export default {
  defaultTab,
  filterQuestions,
  getCardStyle,
  resolveEvidences,
  status,
  statusChipColor,
}
